import { render, staticRenderFns } from "./UsuarioList.vue?vue&type=template&id=36783b4c"
import script from "./UsuarioList.vue?vue&type=script&lang=js"
export * from "./UsuarioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports